import { useEffect, useCallback, useState, useRef } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import WxWorkProvider from '@cloud/wxwork-workbench';
import ScreenContext, { ScreenContextValue, getScreenContextValue } from './contexts/screen';
import Toast from './components/Toast';
import Routes from './pages/routes';
import { login } from './services';
import { API_DOMAIN } from './constants';
import './global.less';


axios.defaults.baseURL = API_DOMAIN[process.env.REACT_APP_API];

axios.interceptors.response.use(res => {
  if (res.data && res.data.code === 0) {
    res.data = res.data.data;
    return res;
  } else {
    const msg = res?.data?.message || '网络错误，请稍后重试';
    console.log(res);
    Toast.error(msg);
    return Promise.reject(msg)
  }
}, error => {
  console.log(error);
  if (error?.response?.data?.message) {
    Toast.error(error.response.data.message);
  }
  return Promise.reject(error);
});

const App = () => {
  const { current: _this } = useRef<{ timer?: NodeJS.Timeout }>({});
  const [screenContext, setScreenContext] = useState<ScreenContextValue>(getScreenContextValue());

  const resize = useCallback(() => {
    if (_this) {
      // debounce
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
      _this.timer = setTimeout(() => {
        setScreenContext(getScreenContextValue());
        delete _this.timer;
      }, 300);
    }
  }, [_this]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    }
  }, [resize]);

  return (
    <ScreenContext.Provider value={screenContext}>
      <WxWorkProvider config={{
        loginRequest: login
      }}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Routes />
        </BrowserRouter>
      </WxWorkProvider>
    </ScreenContext.Provider>
  )
};

render(<App />, document.getElementById('root'));
